export default "__VITE_ASSET__2ae3f032__"